import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ghep } from '../lib/duong-dan-cong';
import { duocVaoCong, phamViCuaRoute } from '../lib/pham-vi-route';
import { usePhamVi } from './usePhamVi';

/**
 * Ghép tiền tố cổng vào đường dẫn gốc, theo **cổng đang xem** nếu người dùng được vào cổng đó,
 * không thì theo cổng của tài khoản.
 *
 * Trước đây chỉ theo cổng của tài khoản, nên nhân sự nền tảng đang xem chéo `/client/...` bấm một
 * liên kết trong màn tenant lại bị đưa sang `/admin/...` và ra màn "Không tìm thấy trang" — đúng
 * điều đoạn dưới muốn tránh (gặp khi soát màn OCR của đợt 5).
 *
 * Component viết đường dẫn **gốc** (`/xu-ly/chung-tu`) rồi để hàm này lo tiền
 * tố. Viết thẳng `/client/xu-ly/chung-tu` trong view là ghim màn đó vào một
 * cổng, và nhân sự nền tảng đang xem giao diện tenant sẽ bị văng về nhánh kia
 * giữa chừng.
 */
export function useDuongDan(): (duongDanGoc: string) => string {
  const cuaToi = usePhamVi();
  const { pathname } = useLocation();
  const dangXem = phamViCuaRoute(pathname);
  const phamVi = dangXem && duocVaoCong(cuaToi, dangXem) ? dangXem : cuaToi;
  return useCallback((duongDanGoc: string) => ghep(duongDanGoc, phamVi), [phamVi]);
}

/**
 * `navigate()` tự ghép tiền tố cổng — bản thay thế trực tiếp cho `useNavigate`
 * ở mọi chỗ điều hướng bằng đường dẫn gốc.
 *
 * Chỉ nhận chuỗi. Điều hướng bằng số (`navigate(-1)`) vẫn dùng `useNavigate`
 * thẳng: nó đi theo lịch sử chứ không theo đường dẫn, nên không có gì để ghép.
 */
export function useDieuHuong(): (duongDanGoc: string, tuyChon?: { replace?: boolean }) => void {
  const navigate = useNavigate();
  const duongDan = useDuongDan();
  return useCallback(
    (duongDanGoc: string, tuyChon?: { replace?: boolean }) => {
      navigate(duongDan(duongDanGoc), tuyChon);
    },
    [navigate, duongDan],
  );
}
